<!-- 
	商品列表组件 
	1、商品列表：商品列表数组
	2、基础设置：组件上边距、组件下边距、组件背景色、背景是否整体式 0 否  1是、背景圆角、单个商品圆角
	3、销售价设置：销售价文字颜色、销售价文案
-->
<template>
	<view v-if="list.length > 0" :style="componentStyle">
		<!--一行一列-->
		<!--  style="padding: 0 20rpx 10rpx" -->
		<up-grid v-if="data.prodStyle === 'S1'" :border="false" gap="5px" col="1">
			<up-grid-item v-for="(item,index) in list" :key="index">
				<!--商品图片-->
				<view class="component-wrapper1">
					<view class="item-image f_c_c_c" @click="navigateTo(item)">
						<view class="image-goods">
							<image :src="getImageUrl(item.mainLagerImgUrl)" style="width: 100%;border-radius: 5px" mode="widthFix"></image>
						</view>
						<view class="item-soldOut" :style="labelStyle">
							<span :style="labelStyle">{{data.labelText}}</span>
						</view>
					</view>
					<view class="item-info">
						<!--sku标题-->
						<view class="item-title uni-ellipsis" :style="titleWidthStyle">
							{{ item.prodName }}
						</view>
						<view class="item-shop-market">
							<!--会员价格-->
							<view class="item-shop bold" :style="fontPriceStyle">
								<view class="shop-title" :style="priceStyle">{{membType==1?'会员价':'官方价'}}</view>
								<span class="shop-title-block" style="font-size: 22rpx;margin-right: 14rpx;margin-left: 10rpx;">￥</span>
								<view class="shop-price" :style="priceStyle">
									{{membType==1?item.minPrice:item.minUdValue}}
								</view>
							</view>
						</view>
					</view>
				</view>
			</up-grid-item>
		</up-grid>
		<!--一行二列-->
		<!-- style="padding: 0 20rpx 10rpx;" -->
		<up-grid v-if="data.prodStyle === 'S2'" :border="false" gap="5px" col="2" >
			<up-grid-item v-for="(item,index) in list" :key="index">
				<!--商品图片-->
				<view class="component-wrapper2">
					<view class="item-image" @click="navigateTo(item)">
						<view class="image-goods">
							<image :src="getImageUrl(item.mainLagerImgUrl)"  style="width: 100%;border-radius: 5px;" mode="widthFix"></image>
						</view>
						<view class="item-soldOut" :style="labelStyle">
							<span :style="labelStyle">{{data.labelText}}</span>
						</view>
					</view>
					<view class="item-info">
						<!--sku标题-->
						<view class="item-title" :style="titleWidthStyle">
							{{ item.prodName }}
						</view>
						<view class="item-shop-market">
							<!--会员价格-->
							<view class="item-shop bold" :style="fontPriceStyle">
								<view class="shop-title" :style="priceStyle">{{membType==1?'会员价':'官方价'}}</view>
								<span class="shop-title-block" style="font-size: 22rpx;margin-right: 14rpx;margin-left: 10rpx;">￥</span>
								<view class="shop-price" :style="priceStyle">
									{{membType==1?item.minPrice:item.minUdValue}}
								</view>
							</view>
						</view>
					</view>
				</view>
			</up-grid-item>
		</up-grid>
		<!--一行三列-->
		<!--  style="padding: 0 20rpx 10rpx;" -->
		<up-grid v-if="data.prodStyle === 'S5'" :border="false" gap="5px" col="3">
			<up-grid-item v-for="(item,index) in list" :key="index">
				<!--商品图片-->
				<view class="component-wrapper3">
					<view class="item-image" @click="navigateTo(item)">
						<view class="image-goods">
							<image :src="getImageUrl(item.mainLagerImgUrl)"  style="width: 100%;border-radius: 5px" mode="widthFix"></image>
						</view>
						<view class="item-soldOut" :style="labelStyle">
							<span :style="labelStyle">{{data.labelText}}</span>
						</view>
					</view>
					<view class="item-info">
						<!--sku标题-->
						<view class="item-title" :style="titleWidthStyle">
							{{ item.prodName }}
						</view>
						<view class="item-shop-market">
							<!--会员价格-->
							<view class="item-shop bold" :style="fontPriceStyle">
								<view class="shop-title" :style="priceStyle">{{membType==1?'会员价':'官方价'}}</view>
								<span class="shop-title-block" style="font-size: 22rpx;margin-right: 14rpx;margin-left: 10rpx;">￥</span>
								<view class="shop-price" :style="priceStyle">
									{{membType==1?item.minPrice:item.minUdValue}}
								</view>
							</view>
						</view>
					</view>
				</view>
			</up-grid-item>
		</up-grid>
	</view>
</template>

<script setup>
	import {fnImgRequestPath} from "@/utils/utils";
	import { getCurrentInstance, reactive, ref, computed} from "vue";
	import {onLoad, onShow} from '@dcloudio/uni-app'
	const { ctx } = getCurrentInstance(); //获取上下文实例，ctx=vue2的this
	const membType = ref(0)
	/**
	 * 页面加载时执行的函数
	 * @param {Object} options - 页面参数
	 */
	onLoad((options) => {
		const memb = uni.getStorageSync('lifeData').vuex_user
		if (memb) {
		    membType.value = memb.membType || 0
		}
	})
	const props = defineProps({
		componentId: {
			type: String,
			default: ''
		},
		data: {
			type: Object,
			default () {
				return {
					//展示风格（ S1大图  S2 小图 S3 一大一小  S4详细列表）
					"prodStyle": {
						type: String,
						default: 'S1'
					},
					//商品列表数组
					"decorateProdDetailBoList": {
						type: Array,
						default: []
					},
					//组件上边距
					"marginTop": {
						type: Number,
						default: 0
					},
					//组件下边距
					"marginBottom": {
						type: Number,
						default: 0
					},
					//组件背景色
					"bgColor": {
						type: String,
						default: '#f8f8f8'
					},
					//背景是否整体式 0 否  1是
					"boxIsWhole": {
						type: String,
						default: '0'
					},
					//背景圆角
					"bgRadius": {
						type: Number,
						default: '12'
					},
					//单个商品圆角
					"itemRadius": {
						type: Number,
						default: '12'
					},
					///销售价文字颜色
					"shopPriceColor": {
						type: String,
						default: '#333333'
					},
					//销售价文案
					"shopPriceTitle": {
						type: String,
						default: '售价'
					},
					//左右填充边距
					"paddingLeftRight": {
						type: Nmber,
						default: 0
					},
					//名称字体大小
					"nameFontSize": {
						type: Nmber,
						default: 12
					},
					//标签字体大小
					"labelFontSize": {
						type: Nmber,
						default: 12
					},
					//标签背景颜色
					"labelBackgroundColor": {
						type: String,
						default: ''
					},
					//价格字体大小
					"priceFontSize": {
						type: Nmber,
						default: 12
					},
					/**
					 * 背景颜色
					 */
					"backgroundColor":  {
						type: String,
						default: "#ffffff"
					},
					/**
					 * 背景图片
					 */
					"backgroundUrl":  {
						type: String,
						default: ""
					}
				}
			}
		}
	})
	
	/**
	 * 组件背景样式
	 */
	const componentStyle = computed(() => {
		const {
			paddingLeftRight,
			backgroundColor,
			backgroundUrl
		} = props.data;
		return `
			padding-left: ${paddingLeftRight}px;
			padding-right: ${paddingLeftRight}px;
			background-color: ${backgroundColor == undefined ? '#f8f8f8': ''};
			background-image: url(${backgroundUrl ? getImageUrl(backgroundUrl) : ''});
			background-repeat: repeat;
			background-size: 100% 100%;
			bakcground-position: center;
		`;
	})
	
	/**
	 * 字体价格样式
	 */
	const fontPriceStyle = computed(() => {
		const {
			priceFontSize
		} = props.data;
		return `
			color: #3a8a79;
			margin-top: 14rpx;
			margin-bottom: 14rpx;
			font-size: ${priceFontSize}px;
		`
	})
	
	/**
	 * 价格样式
	 */
	const priceStyle = computed(() => {
		const {
			priceFontSize
		} = props.data;
		return `
			font-size: ${priceFontSize}px;
		`
	})
	
	/**
	 * 动态计算标题宽度
	 */
	const titleWidthStyle = computed(() => {
		const {
			paddingLeftRight,
			prodStyle,
			nameFontSize
		} = props.data;
		const plr = uni.upx2px(paddingLeftRight)
		if(prodStyle === 'S1'){
			return `
				width: ${680 - plr*5}rpx;
				font-size: ${nameFontSize}px;
			`;
		}else if(prodStyle === 'S2'){
			return `
				width: ${300 - plr}rpx;
				font-size: ${nameFontSize}px;
			`;
		}else if(prodStyle === 'S5'){
			return `
				width: ${180 - plr}rpx;
				font-size: ${nameFontSize}px;
			`;
		}else{
			return `
			`;
		}
	})

	/**
     * 标签样式
	 */
	const labelStyle = computed(() => {
		const {
			labelFontSize,
			labelBackgroundColor
		} = props.data;
		return `
			font-size: ${labelFontSize}px;
			background-color: ${labelBackgroundColor};
		`;
	});
	
	/**
	 * 数据
	 */
	const list = computed(() => {
		if (props.data.decorateProdDetailBoList != null && props.data.decorateProdDetailBoList != undefined && props.data.decorateProdDetailBoList.length > 0) {
			return props.data.decorateProdDetailBoList;
		}
		return [];
	})
	
	/**
	 * 获取图片地址
	 */
	function getImageUrl(imgUrl){
		return fnImgRequestPath(imgUrl);
	}
	
	/**
	 * 页面跳转
	 * @param {Object} item
	 */
	function navigateTo(item) {
		// 商品ID
		let prodId = item.prodId
		uni.navigateTo({
			url: '/pages/prodDetail/detail?prodId=' + prodId,
		})
	}
</script>

<style lang="less" scoped>
	
	/**
	 * 组件样式1 一行一列
	 */
	.component-wrapper1 {
		width: 100%;
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
		align-items: center;
		border-radius: 5px;

		// padding: 20rpx 10rpx!important;

		// 商品图片
		.item-image {
			// height: 710rpx;
			width: 100%;
			padding: 10px;
			
			
			.image-goods {
				// height: 710rpx;
				width: 100%;
			}
		}

		// 商品详情
		.item-info {
			padding-left: 10px;
			padding-right: 10px;
			margin-bottom: 5px;
			width: 100%;
			margin-top: 10px;
			
			// 标题
			.item-title {
				box-sizing: content-box;
				//width: 675rpx;
				font-size: 26rpx;
				//min-height: 15px;
				// line-height: 15px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				word-break: keep-all;
				word-wrap: break-word;
				padding-top: 5px;
				margin-bottom: 4px;
				color: #333333;
			}
			
			// 销售价
			.item-shop-market {
				width: 100%;
				
				.item-shop {
					display: flex;
					flex-flow: row wrap;
					color: #333333;
					//line-height: 24px;
					align-items: baseline;
				
					.shop-title {
						font-size: 13px;
						max-width: 147px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						word-break: keep-all;
						word-wrap: break-word;
					}
				
					.shop-title-block {
						display: inline-block;
						width: 4px;
					}
				
					.shop-price {
						font-size: 34rpx !important;
						font-weight: bold;
					}
				}
				
				.item-market {
					color: #999999;
					line-height: 17px;
				}
			}
		}
		
		// 标签
		.item-soldOut {
			position: absolute;
			top: 0px;
			left: 0px;
			min-width: 80px;
			height: 30px;
			line-height: 30px;
			border-radius: 5px 0px 5px 0px;
			background-color: #179A16;
			z-index: 1;
			text-align: center;
			color: #FFFFFF;
			// font-size: 22rpx;
		}	
	}

	/**
	 * 组件样式2 一行两列
	 */
	.component-wrapper2 {
		width: 100%;
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
		align-items: center;
		border-radius: 5px;
		
		 // 商品图片
		.item-image {
			height: 350rpx;
			width: 100%;
			padding: 10px;
			
			.image-goods {
				height: 200rpx;
				width: 100%;
			}
		}
	 
		// 商品详情
		.item-info {
			padding-left: 10px;
			padding-right: 10px;
			width: 100%;
			margin-bottom: 5px;
			
			margin-top: 10px;
			
			// 标题
			.item-title {
				box-sizing: content-box;
				//width: 300rpx;
				font-size: 26rpx;
				//height: 15px;
				//line-height: 15px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				word-break: keep-all;
				word-wrap: break-word;
				// padding-top: 5px;
				margin-bottom: 4px;
				color: #333333;
			}
			
			// 销售价
			.item-shop-market {
				width: 100%;
				.item-shop {
					display: flex;
					flex-flow: row wrap;
					color: #333333;
					//line-height: 24px;
					align-items: baseline;
				
					.shop-title {
						font-size: 13px;
						max-width: 147px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						word-break: keep-all;
						word-wrap: break-word;
					}
				
					.shop-title-block {
						display: inline-block;
						width: 4px;
					}
				
					.shop-price {
						font-size: 34rpx !important;
						font-weight: bold;
					}
				}
				
				.item-market {
					color: #999999;
					line-height: 17px;
				}
			}
		}
	 		
		// 标签
		.item-soldOut {
			position: absolute;
			top: 0px;
			left: 0px;
			min-width: 80px;
			height: 28px;
			line-height: 28px;
			border-radius: 5px 0px 5px 0px;
			background-color: #179A16;
			z-index: 1;
			text-align: center;
			color: #FFFFFF;
			// font-size: 22rpx;
		}	
	}
	
	
	/**
	 * 组件样式3 一行三列
	 */
	.component-wrapper3 {
		width: 100%;
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
		align-items: center;
		border-radius: 5px;
		
		 // 商品图片
		.item-image {
			height: 225rpx;
			width: 100%;
			padding: 10px;
			
			.image-goods {
				height: 100rpx;
				width: 100%;
			}
		}
	 
		// 商品详情
		.item-info {
			padding-left: 10px;
			padding-right: 10px;
			width: 100%;
			margin-bottom: 2px;
			
			// 标题
			.item-title {
				box-sizing: content-box;
				//width: 180rpx;
				font-size: 24rpx;
				//height: 15px;
				//line-height: 15px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				word-break: keep-all;
				word-wrap: break-word;
				padding-top: 5px;
				margin-bottom: 4px;
				color: #333333;
			}
			
			// 销售价
			.item-shop-market {
				width: 100%;
				.item-shop {
					display: flex;
					flex-flow: row wrap;
					color: #333333;
					//line-height: 24px;
					align-items: baseline;
				
					.shop-title {
						font-size: 13px;
						max-width: 147px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						word-break: keep-all;
						word-wrap: break-word;
					}
				
					.shop-title-block {
						display: inline-block;
						width: 4px;
					}
				
					.shop-price {
						font-size: 34rpx !important;
						font-weight: bold;
					}
				}
				
				.item-market {
					color: #999999;
					line-height: 17px;
				}
			}
		}
	 		
		// 标签
		.item-soldOut {
			position: absolute;
			top: 0px;
			left: 0px;
			min-width: 60px;
			height: 25px;
			line-height: 25px;
			border-radius: 5px 0px 5px 0px;
			background-color: #179A16;
			z-index: 1;
			text-align: center;
			color: #FFFFFF;
			// font-size: 22rpx;
		}	
	}
</style>
